import { render, staticRenderFns } from "./ModalCustomerCategory.vue?vue&type=template&id=a5eb9d74"
import script from "./ModalCustomerCategory.vue?vue&type=script&lang=js"
export * from "./ModalCustomerCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports